/* 🎨 STYLES */
import { LegendItemContainer, ColorIndicator, Label } from "./styles";

const LegendItem = ({ color, text }) => {
    return (
        <LegendItemContainer>
            <ColorIndicator color={color}/>
            <Label color={color}>{text}</Label>
        </LegendItemContainer>
    );
};

export default LegendItem;